import React, { useMemo } from 'react';
import { Input, createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles';

const useStyles = createUseStyles(styles, 'ColorPicker');

function ColorPicker({ placeholder, ...props }) {
    const classes = useStyles();

    const overrides = useMemo(
        () => ({
            postComponent: {
                className: classes.postComponent,
            },
            formControl: { className: classes.formControl },
            inputComponents: {
                className: classes.inputComponents,
            },
            input: {
                className: classes.input,
            },
        }),
        [classes.postComponent, classes.formControl, classes.inputComponents, classes.input],
    );

    return (
        <div>
            <Input labelMode="horizontal" type="color" overrides={overrides} {...props} />
        </div>
    );
}

export default ColorPicker;
